{
  "id": "campaign-158",
  "name": "Willow Fields",
  "seed": "campaign:158",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ".......x..k...........",
    "......*.....#.........",
    ".k....**.h......Y.....",
    ".....,*,..............",
    "....k.................",
    "...T......k...........",
    "..............h.......",
    ".......k.............h",
    "..T...................",
    "......................",
    "..............Y.......",
    "..................m...",
    ".......T..........m...",
    "..,..T............m...",
    ".,.,............x.....",
    "..,..T.........,..#..h",
    ".x.T..........,,,..#..",
    ".......T.......,......",
    ".k....................",
    "......................",
    ".........h.#..........",
    "S....................."
  ],
  "critters": [
    {
      "kind": "deer",
      "x": 18,
      "y": 2
    },
    {
      "kind": "deer",
      "x": 18,
      "y": 1
    },
    {
      "kind": "deer",
      "x": 8,
      "y": 16
    },
    {
      "kind": "deer",
      "x": 8,
      "y": 15
    },
    {
      "kind": "deer",
      "x": 3,
      "y": 15
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 19,
      "y": 13
    },
    {
      "kind": "gas",
      "x": 15,
      "y": 5
    },
    {
      "kind": "gas",
      "x": 5,
      "y": 6
    },
    {
      "kind": "gas",
      "x": 9,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 14,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 18,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 15,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 19,
      "y": 20
    },
    {
      "kind": "coin",
      "x": 12,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 20
    }
  ],
  "hills": [
    {
      "x": 3,
      "y": 3,
      "w": 7,
      "h": 7
    },
    {
      "x": 2,
      "y": 14,
      "w": 5,
      "h": 5
    }
  ],
  "generatorVersion": 3,
  "level": 158,
  "biome": "meadow",
  "par": {
    "reel": 16666,
    "push": 14446,
    "selfPropelled": 13319,
    "tractor": 10874,
    "zeroTurn": 9233,
    "fairway": 5424
  },
  "goldTime": {
    "reel": 16666,
    "push": 14446,
    "selfPropelled": 13319,
    "tractor": 10874,
    "zeroTurn": 9233,
    "fairway": 5281
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 0,
      "zeroTurn": 0,
      "fairway": 5
    },
    "gold": {
      "reel": 0,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 0,
      "zeroTurn": 0,
      "fairway": 47
    }
  }
}
